import type { RetainerAgreementWithFileDetails } from '@common/types/retainerAgreements';
import { buildUnsignedRetainerPdfFileName } from '@common/utils/retainerDocumentNaming';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import PDFViewer from '@/components/PdfViewer/PdfViewer';
import { THIN_SCROLLBAR_STYLING } from '@/constants';

interface Props {
    selectedDocument: RetainerAgreementWithFileDetails;
    onClose(): void;
}

export default function ViewRetainerModal({ selectedDocument, onClose }: Props) {
    const pdfUrl = selectedDocument.previewFileId
        ? `${import.meta.env.VITE_APP_API_URL}/api/v1/files/${selectedDocument.previewFileId}`
        : `${import.meta.env.VITE_APP_API_URL}/api/v1/files/${selectedDocument.fileId}/WordToPdf`;
    const downloadFileName = buildUnsignedRetainerPdfFileName(
        selectedDocument.documentDisplayName ?? null,
    );

    return (
        <Dialog
            open
            maxWidth={false}
            PaperProps={{
                sx: {
                    width: '80vw',
                    height: '80vh',
                },
            }}
        >
            <DialogTitle>Document Preview</DialogTitle>
            <DialogContent sx={THIN_SCROLLBAR_STYLING}>
                <PDFViewer pdfUrl={pdfUrl} downloadFileName={downloadFileName} />
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={onClose}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}
